import React from 'react';
import PropTypes from 'prop-types';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { Field } from '@plone/volto/components';
import { useTeaserData, Teaser } from './View';
import { useIntl } from 'react-intl';
import messages from '../../../../messages';

const TeaserSidebar = ({ data = {}, block, onChangeBlock }) => {
  const handle = (id, value) => {
    onChangeBlock(block, { ...data, [id]: value });
  };

  const intl = useIntl();

  return (
    <div className="ui form">
      <header className="header pulled">
        <h2>FCMH Teaser</h2>
      </header>

      <fieldset>
        <legend>Inhalt</legend>

        <Field
          id="item"
          title={intl.formatMessage(messages.linkItemSchemaGoal)}
          widget="object_browser"
          mode="link"
          required
          allowExternals={false}
          value={data.item || null}
          onChange={handle}
        />

        <Field
          id="kicker"
         title={intl.formatMessage(messages.teaserHeadtitle)}
          value={data.kicker || ''}
          onChange={handle}
        />

        <Field
          id="title"
          title={intl.formatMessage(messages.headerTitle)}
          value={data.title || ''}
          onChange={handle}
        />

        <Field
          id="description"
          title={intl.formatMessage(messages.headerDescription)}
          widget="textarea"
          value={data.description || ''}
          onChange={handle}
        />

        <Field
          id="image"
          title={intl.formatMessage(messages.teaserOverrideImage)}
          widget="object_browser"
          mode="image"
          value={data.image || null}
          onChange={handle}
        />

        <Field
          id="buttonText"
          title="Button Text"
          value={data.buttonText ?? 'Weiterlesen'}
          onChange={handle}
        />

        <Field
          id="hideButton"
          title={intl.formatMessage(messages.teaserButton)}
          type="boolean"
          value={Boolean(data.hideButton)}
          onChange={handle}
        />
      </fieldset>

      <fieldset>
        <legend>{intl.formatMessage(messages.quoteStil)}</legend>

        <Field
          id="flagAlign"
          title={intl.formatMessage(messages.statisticsAlignment)}
          widget="inner_align"
          actions={['left', 'right']}
          value={data.flagAlign || 'left'}
          onChange={handle}
        />

        <Field
          id="background_color"
          title="Hintergrundfarbe"
          description="Wähle die Hintergrundfarbe."
          widget="fcmhColorSelect"
          value={data.background_color || 'gray'}
          onChange={handle}
          choices={[
            ['gray', 'Grau'],
            ['white', 'Weiß'],
            ['blue', 'Blau'],
            ['yellow', 'Gelb'],
          ]}
        />
      </fieldset>
    </div>
  );
};

const TeaserEdit = (props) => {
  const { data, selected, onChangeBlock, block } = props;
  const state = useTeaserData(data);

  return (
    <>
      <Teaser {...state} isEditMode />
      <SidebarPortal selected={selected}>
        <TeaserSidebar
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

TeaserEdit.propTypes = {
  data: PropTypes.object,
  selected: PropTypes.bool,
  onChangeBlock: PropTypes.func,
  block: PropTypes.string,
};

export default TeaserEdit;
